import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Volleyball = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1C440 177.2 399.3 78.3 327.6 10.1 434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7-97.5 48.5-217.7 42.6-311.9-24.5 23.7-36.2 55.4-67.7 94.5-91.8 79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5C269.4 155.7 230.8 73.9 170 14.9 196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9.1 90.8 60.2 145.7 167.2 134.7 282.3-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9 2.5 297.4 0 277 0 256 0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7-77.4 47.6-129 121.9-149.7 204-24.2-20.6-44.6-45.6-59.8-73.8 6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2 5.6-27 14.8-53.1 27.4-77.7 86.6 60.5 192.5 74.7 287.4 46.9-46 44-108.3 71-177 71z"
  }));
});
Volleyball.displayName = 'Volleyball';
export var VolleyballDimensions = {
  height: 512,
  width: 512
};